<template>
    <NuxtLayout>
        <div data-page class="py-20 container-extra-wide mx-auto">
            <div class="flex items-center justify-center">
                <div class="flex flex-col justify-center items-center space-y-4">
                    <p class="text-center text-neutral-base text-sm leading-sm font-ux font-semibold">{{ error.statusCode }}</p>
                    <h1 class="text-center text-5xl leading-5xl font-brand-heading font-heading">{{ error.statusMessage ?? 'Something went wrong' }}</h1>

                    <div v-if="error.message" class="flex justify-center max-w-[450px] text-center ">
                        <p class="text-neutral-base text-base leading-base whitespace-pre-wrap" v-html="error.message" />
                    </div>
                    <DButton v-if="error.stack" theme="transparent" left-icon="code-bracket-16-solid" @click="showStack = !showStack">See stack</DButton>
                    <pre v-if="showStack" class="text-xs" v-html="error.stack"/>

                <!-- <div v-if="error.statusCode !== 500" class="w-full flex justify-center pt-10">
                        <NuxtLink to="/">
                            <DButton size="lg">Back to homepage</DButton>
                        </NuxtLink>
                    </div> -->
                </div>
            </div>
        </div>
    </NuxtLayout>
</template>

<script setup>
    import { DButton } from '@digistorm/spark'

    defineProps({
        error: Object
    })

    const showStack = ref(false)
</script>
